var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useRef, useCallback } from 'react';
import { ThemeProvider } from '@cvent/carina/components/ThemeProvider/ThemeProvider';
import { getDarkTheme, getDefaultTheme } from '@cvent/carina/utils/tokens';
import { LoadingSpinner } from '@cvent/carina/components/LoadingSpinner';
import { PageAlert } from '@cvent/carina/components/Alert/PageAlert';
import { TextLink } from '@cvent/carina/components/TextLink';
import { css } from '@emotion/react';
import Postmate from 'postmate';
import useAsync from '@jamsesso/use-async';
import { Modal } from './Modal';
import { EmbeddedEditor } from './EmbeddedEditor';
import useEditorClient from './hooks/use-editor-client';
Postmate.debug = true;
export var VideoEditorErrorType;
(function (VideoEditorErrorType) {
    VideoEditorErrorType["UNAUTHORIZED"] = "unauthorized";
    VideoEditorErrorType["PROJECT_NOT_FOUND"] = "project_not_found";
    VideoEditorErrorType["VIDEO_NOT_FOUND"] = "video_not_found";
    VideoEditorErrorType["ERROR"] = "error";
})(VideoEditorErrorType || (VideoEditorErrorType = {}));
export function CventVideoEditor(_a) {
    var url = _a.url, environment = _a.environment, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, projectId = _a.projectId, _c = _a.mode, mode = _c === void 0 ? 'VIDEO' : _c, actions = _a.actions, onClose = _a.onClose, onError = _a.onError, onRenderComplete = _a.onRenderComplete, _d = _a.theme, theme = _d === void 0 ? 'DEFAULT' : _d, _e = _a.display, display = _e === void 0 ? 'MODAL' : _e, _f = _a.iframeTitle, iframeTitle = _f === void 0 ? 'Video Editor' : _f, locale = _a.locale;
    var themeSetting = theme === 'DARK' ? getDarkTheme() : getDefaultTheme();
    var videoEditorNode = (_jsx(VideoEditorFrame, { url: url, environment: environment, projectId: projectId, theme: theme, mode: mode, actions: actions, onClose: onClose, onError: onError, onRenderComplete: onRenderComplete, isModal: display === 'MODAL', iframeTitle: iframeTitle, locale: locale }));
    if (display === 'MODAL') {
        return (_jsx(ThemeProvider, __assign({ theme: themeSetting }, { children: _jsx(Modal, __assign({ disableFocusTrap: true, portal: true, format: "fullscreen", isOpen: isOpen }, { children: videoEditorNode })) })));
    }
    return _jsx(ThemeProvider, __assign({ theme: themeSetting }, { children: videoEditorNode }));
}
function VideoEditorFrame(_a) {
    var _this = this;
    var url = _a.url, environment = _a.environment, projectId = _a.projectId, mode = _a.mode, theme = _a.theme, actions = _a.actions, onClose = _a.onClose, onError = _a.onError, onRenderComplete = _a.onRenderComplete, isModal = _a.isModal, iframeTitle = _a.iframeTitle, locale = _a.locale;
    var container = useRef(null);
    var _b = useAsync(useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var localeQuery, fullUrl, cleansedActions;
        return __generator(this, function (_a) {
            if (container.current) {
                localeQuery = locale ? "&locale=".concat(locale) : '';
                fullUrl = "".concat(url, "/project/").concat(projectId, "/").concat(mode === null || mode === void 0 ? void 0 : mode.toLowerCase(), "?theme=").concat(theme === null || theme === void 0 ? void 0 : theme.toLowerCase(), "&environment=").concat(environment, "&isModal=").concat(isModal).concat(localeQuery);
                cleansedActions = actions === null || actions === void 0 ? void 0 : actions.map(function (action, index) {
                    var newAction = { index: index, value: action.value };
                    Object.keys(action).forEach(function (key) {
                        if (typeof action[key] === 'function') {
                            newAction.hasCallback = true;
                        }
                        else {
                            newAction[key] = action[key];
                        }
                    });
                    return newAction;
                });
                return [2 /*return*/, EmbeddedEditor.connect(fullUrl, container.current, cleansedActions, iframeTitle)];
            }
            throw new Error('No container element was available to mount the video editor into');
        });
    }); }, [locale, url, projectId, mode, theme, environment, isModal, actions, iframeTitle])), launchEditor = _b[0], _c = _b[1], loading = _c.loading, error = _c.error, editor = _c.result;
    var editorClient = useEditorClient({ editor: editor, environment: environment, projectId: projectId, mode: mode });
    useEffect(function () {
        launchEditor();
    }, [launchEditor]);
    useEffect(function () {
        var ref = editor;
        return function () {
            if (ref) {
                ref.destroy();
            }
        };
    }, [editor]);
    useEffect(function () {
        if (editor) {
            editor.on('exit', onClose);
            editor.on('renderComplete', function (job) {
                onRenderComplete(job);
            });
            editor.on('done', function (action) { return __awaiter(_this, void 0, void 0, function () {
                var onClick;
                return __generator(this, function (_a) {
                    if (actions) {
                        onClick = actions[action.index].onClick;
                        if (onClick)
                            onClick(editorClient);
                    }
                    return [2 /*return*/];
                });
            }); });
            editor.on('error', function (err) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (onError) {
                        onError(err);
                    }
                    return [2 /*return*/];
                });
            }); });
        }
    }, [editor, onClose, onError, onRenderComplete, actions, editorClient]);
    return (_jsxs(_Fragment, { children: [loading && _jsx(LoadingView, {}), error && _jsx(ErrorView, { error: error, onClose: onClose }), _jsx("div", { ref: container, css: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          width: ", ";\n          height: ", ";\n\n          iframe {\n            border: 0;\n            width: 100%;\n            height: 100%;\n          }\n        "], ["\n          width: ", ";\n          height: ", ";\n\n          iframe {\n            border: 0;\n            width: 100%;\n            height: 100%;\n          }\n        "])), editor ? '100%' : '0px', editor ? '100%' : '0px') })] }));
}
function LoadingView() {
    return (_jsx("div", __assign({ css: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: flex;\n        width: 100%;\n        height: 100%;\n        align-items: center;\n        justify-content: center;\n      "], ["\n        display: flex;\n        width: 100%;\n        height: 100%;\n        align-items: center;\n        justify-content: center;\n      "]))) }, { children: _jsx(LoadingSpinner, { size: "m" }) })));
}
function ErrorView(_a) {
    var error = _a.error, onClose = _a.onClose;
    return (_jsx("div", __assign({ css: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        display: flex;\n        width: 100%;\n        height: 100%;\n        padding: 2rem;\n        align-items: center;\n        justify-content: center;\n      "], ["\n        display: flex;\n        width: 100%;\n        height: 100%;\n        padding: 2rem;\n        align-items: center;\n        justify-content: center;\n      "]))) }, { children: _jsx("div", __assign({ css: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n          min-height: 120px;\n          max-width: 600px;\n          margin: 0 auto;\n        "], ["\n          min-height: 120px;\n          max-width: 600px;\n          margin: 0 auto;\n        "]))) }, { children: _jsx(PageAlert, { appearance: "danger", id: "1", title: "Video editor failed to load", content: "A problem occurred while trying to launch the video editor: ".concat(error.toString()), action: 
                // eslint-disable-next-line react/jsx-wrap-multilines
                _jsx(TextLink, __assign({ onClick: onClose, bold: true }, { children: "Close" })), actionPosition: "bottom", dismissible: false }) })) })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map